import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { setClickActionBoxContent, setCurrentStep } from "../../redux";
import { setClickActionLink, setClickActionType } from "../../redux";
import {
  getClickActionBoxContent,
  getClickActionLink,
  getClickActionType,
  getCurrentHotspot,
  getCurrentStep,
} from "../../redux/selectors";
import { ConfigureClickActionBoxLocation } from "../ConfigureClickActionBoxLocation/ConfigureClickActionBoxLocation";
import debounce from "lodash.debounce";
import { TextEditor } from "../TextEditor/TextEditor";
import { stripBr } from "../../util/general";
import { useStyles } from "../../util/useStyles";
import { steps } from "../../util/constants";
import Section from "../Section/Section";

export const ConfigureClickAction = ({ style }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const debouncedDispatch = debounce(dispatch, 400);
  const selectedActionType = useSelector(getClickActionType);
  const currentStep = useSelector(getCurrentStep);
  const link = useSelector(getClickActionLink);
  const hotspotIndex = useSelector(getCurrentHotspot);
  const handleBoxChange = (e) => {
    if (selectedActionType !== "box") {
      return;
    }
    const content = e.target.value.replace(/\n/g, "<br/>\n");
    debouncedDispatch(
      setClickActionBoxContent({
        hotspotIndex,
        content,
      })
    );
  };
  const handleSelectChange = (e) => {
    const actionType = e.target.value;
    dispatch(setClickActionType({ hotspotIndex, actionType }));
  };
  const setLink = (e) => {
    const actionValue = e.target.value;
    dispatch(
      setClickActionLink({
        hotspotIndex,
        actionValue,
      })
    );
  };
  const boxContent = stripBr(useSelector(getClickActionBoxContent)) ?? "";
  const content = {
    box: (
      <>
        <TextEditor
          key={hotspotIndex}
          autoFocus={steps.configureClickAction === currentStep}
          initialValue={boxContent}
          onChange={selectedActionType === "box" ? handleBoxChange : null}
        />
        <ConfigureClickActionBoxLocation />
      </>
    ),
    link: (
      <>
        <div className="spacer" />
        <TextField
          key={hotspotIndex}
          fullWidth
          label="Enter URL"
          value={link}
          onChange={setLink}
          InputProps={{
            classes: {
              input: classes.menuItem,
            },
          }}
        />
      </>
    ),
  };

  return (
    <Section
      title="Click action"
      className="configureMessageSectionContainer"
      style={style}
      onClick={() => dispatch(setCurrentStep(steps.configureClickAction))}
    >
      <div style={{ padding: "0rem 1rem 0 1rem" }}>
        <div className="configureMessageHeaderContainer">
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="click-action-type"
              name="controlled-radio-buttons-group"
              value={selectedActionType}
              onChange={handleSelectChange}
            >
              <FormControlLabel
                value="box"
                label="Message"
                control={<Radio />}
                classes={{
                  label: classes.menuItem,
                }}
              />
              <FormControlLabel
                value="link"
                label="Link to URL"
                control={<Radio />}
                classes={{
                  label: classes.menuItem,
                }}
              />
            </RadioGroup>
          </FormControl>
        </div>
        {content[selectedActionType]}
      </div>
    </Section>
  );
};
